var keyboard = "https://shopfront-cdn.tekoapis.com/static/c1839840a81c5861.svg";

export { keyboard as default };
